module.exports = __webpack_public_path__ + "img/pokeah_eynayim_no.69bd9d82.png";